import styled from 'styled-components';

export const TooltipContainer = styled.div<{ $position: string }>`
  /* AJUSTE: position:fixed faz o tooltip acompanhar o scroll junto com o target.
     Se mudar para 'absolute', precisará somar window.scrollY/X no cálculo de posição. */
  position: fixed;
  background: #ffffff;

  border-radius: 0.44rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  padding: 0.88rem;
  z-index: 2100;
  min-width: 15.56rem;
  max-width: 28rem;
  width: auto;
  max-height: 80vh;
  overflow: hidden;
  animation: fadeIn 0.3s ease;

  &:before {
    content: '';
    position: absolute;
    width: 12px;
    height: 12px;
    background: #ffffff;
    transform: rotate(45deg);

    ${props => {
      switch (props.$position) {
        case 'top':
          return `
            bottom: -6px;
            left: 50%;
            margin-left: -6px;
          `;
        case 'right':
          return `
            left: -6px;
            top: 50%;
            margin-top: -6px;
          `;
        case 'bottom':
          return `
            top: -6px;
            left: 50%;
            margin-left: -6px;
          `;
        case 'left':
          return `
            right: -6px;
            top: 50%;
            margin-top: -6px;
          `;
        default:
          return `
            display: none;
          `;
      }
    }}
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: scale(0.95);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.67rem;
`;

export const Title = styled.h3`
  font-family: 'RedHatDisplay-Bold';
  font-size: 1.125rem;
  color: #1e88e5;
  margin: 0;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.22rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
`;

export const Description = styled.p`
  font-family: 'RedHatDisplay-Regular';
  font-size: 0.875rem;
  line-height: 1.4;
  color: #3a3a3a;
  margin: 0 0 16px 0;
`;

export const PointsInfo = styled.div`
  margin-bottom: 0.88rem;
`;

export const PointsBadge = styled.div`
  background: #f39519;
  color: white;
  font-family: 'RedHatDisplay-Bold';
  font-size: 0.75rem;
  padding: 0.22rem 0.56rem;
  border-radius: 0.67rem;
  display: inline-block;
`;

export const Actions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  .secondary-button {
    pointer-events: auto;
    display: flex;
    padding: 0.5rem 1rem;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    color: #323232;
    line-height: 1.28rem;
    border-radius: 0.55rem;
    vertical-align: center;
    gap: 1rem;
  }

  .primary-button {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #fff;
    border: none;
    padding: 0.5rem 1rem;
    border-radius: 4px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s;

    svg {
      margin-left: 0.5rem;
    }

    &.disabled {
      cursor: not-allowed;
    }
  }
`;

// Add these new styled components to your existing styles.ts file

export const RequiredActionNote = styled.div`
  display: flex;
  align-items: center;
  font-size: 0.85rem;
  color: #1e88e5;
  margin-bottom: 1rem;
  padding: 0.5rem;
  background: rgba(30, 136, 229, 0.1);
  border-radius: 4px;

  svg {
    margin-right: 0.5rem;
  }
`;

// Also update the CompleteButton style to handle the secondary state
export const CompleteButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #1e88e5;
  color: #fff;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background: #1976d2;
  }

  svg {
    margin-left: 0.5rem;
  }
`;
